import { render } from "./Index.vue?vue&type=template&id=762cccb3&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=762cccb3&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762cccb3"],['__file',"resources/js/views/Event/Create/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "762cccb3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('762cccb3', __exports__)) {
    console.log('reload')
    api.reload('762cccb3', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=762cccb3&scoped=true", () => {
    console.log('re-render')
    api.rerender('762cccb3', render)
  })

}


export default __exports__